import React from "react";
import "./footer.css";

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
            <ul>
              <li>NEWS</li>
              <li>SPORT</li>
              <li>WEATHER</li>
              <li>FUTURE</li>
            </ul>
      </div>
    </footer>
  );
}
